// The days Book & pay offers as chips: Today (only before the same-day
// cutoff), then the next twelve days, every one the same weight, none chosen
// on load. Robin, 9 Oct 2026: "only issue with date it its helpful when they
// book further in advance, so today, tomorrow, day after stresses
// operations.." A fortnight on screen at once makes next week as easy to tap
// as tomorrow, and nothing nudges towards short notice: no default, no
// "Tomorrow" word (gowashmycar-research/booking-screen-trim-2026-10-09.md).
//
// Pure, so node --test pins it (day-chips.test.mjs). Days are the browser's
// calendar days; the cutoff is London's (lib/same-day.js).
import { startOfDayPlus } from './date-input.js'

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const CHIP_DAYS = 12

// "Sat" over "11"; a day in a new month (relative to the chip before it, or
// to today for the first) reads "1 Nov". `day` and `month` are the label's
// two parts, so the chip can set the month smaller and keep it inside a
// phone-width chip (25 Oct 2026).
export const dayChips = (now = new Date(), { todayOpen = false, count = CHIP_DAYS } = {}) => {
  const chips = []
  if (todayOpen) {
    chips.push({ date: startOfDayPlus(now, 0), daysAhead: 0, isToday: true, weekday: 'Today', label: null, day: null, month: null })
  }
  let previousMonth = now.getMonth()
  for (let i = 1; i <= count; i++) {
    const date = startOfDayPlus(now, i)
    const newMonth = date.getMonth() !== previousMonth
    previousMonth = date.getMonth()
    chips.push({
      date,
      daysAhead: i,
      isToday: false,
      weekday: WEEKDAYS[date.getDay()],
      label: newMonth ? `${date.getDate()} ${MONTHS[date.getMonth()]}` : String(date.getDate()),
      day: String(date.getDate()),
      month: newMonth ? MONTHS[date.getMonth()] : null
    })
  }
  return chips
}

// "Fri 7 Nov": a day picked from "More dates", read on its chip and in the
// moved-day note ("That day isn't available, so we've moved it to Sat 11.").
export const shortDay = date => `${WEEKDAYS[date.getDay()]} ${date.getDate()}${date.getMonth() !== new Date().getMonth() ? ` ${MONTHS[date.getMonth()]}` : ''}`

// Is `date` one of the chips (so "More dates" stays unpicked)?
export const isChipDay = (date, chips) =>
  !!date && chips.some(c => c.date.getTime() === startOfDayPlus(date, 0).getTime())

// booking_date_chip_selected properties: never the date itself.
export const chipEventProps = (date, now = new Date(), source = 'chip') => {
  const days = Math.round((startOfDayPlus(date, 0) - startOfDayPlus(now, 0)) / 86400000)
  return { days_ahead: days, weekday: WEEKDAYS[date.getDay()], is_today: days === 0, source }
}
